import { Map } from "maplibre-gl";
import { MutableRefObject } from "react";
import { EditingContextStore } from "../../../../context/EditingContext";
import {
  BlocksBySchool,
  SchoolType,
} from "../../../../editing_planning/data_requirements";
import { getIdFromSchoolPlusLevel } from "../../../../utils/editing/helpers";
import { MAP_COLORS, MAP_LAYERS } from "../constants";
import { OPACITIES } from "./styleConstants";

export const colorBlocksByHovered = (
  map: MutableRefObject<Map>,
  editingContextStore: MutableRefObject<EditingContextStore>,
  blocksBySchool: BlocksBySchool,
) => {
  const currentZone = editingContextStore.current.currentZone;
  if (!currentZone) {
    map.current.setPaintProperty(
      MAP_LAYERS.swappableBlocks,
      "fill-color",
      "transparent",
    );
    return;
  }
  const validSwaps = Object.entries(currentZone.swaps)
    ?.filter(([, swap]) => swap.valid)
    ?.map(([pbID]) => parseInt(pbID));
  const invalidSwaps = Object.entries(currentZone.swaps)
    ?.filter(([, swap]) => !swap.valid)
    ?.map(([pbID]) => parseInt(pbID));
  map.current.setPaintProperty(MAP_LAYERS.swappableBlocks, "fill-color", [
    "case",
    [
      "in",
      ["get", "pb_id"],
      ["literal", blocksBySchool?.[currentZone.esID]?.pb_ids],
    ],
    MAP_COLORS.ES,
    ["in", ["get", "pb_id"], ["literal", validSwaps]],
    MAP_COLORS.GREEN,
    ["in", ["get", "pb_id"], ["literal", invalidSwaps]],
    MAP_COLORS.GREY,

    "transparent",
  ]);
};

export const showBoundariesByHovered = (
  map: MutableRefObject<Map>,
  editingContextStore: MutableRefObject<EditingContextStore>,
  level: SchoolType,
) => {
  const currentZone = editingContextStore.current.currentZone;
  if (currentZone) {
    map.current?.setPaintProperty(MAP_LAYERS.allBoundaries, "line-opacity", [
      "case",
      [
        "any",
        ["==", ["get", "level"], level],
        [
          "==",
          ["get", "schoolID"],
          getIdFromSchoolPlusLevel(currentZone?.esID),
        ],
        [
          "==",
          ["get", "schoolID"],
          getIdFromSchoolPlusLevel(currentZone?.msID),
        ],
        [
          "==",
          ["get", "schoolID"],
          getIdFromSchoolPlusLevel(currentZone?.hsID),
        ],
      ],
      OPACITIES.FULL,
      OPACITIES.INVISIBLE,
    ]);
  } else {
    map.current?.setPaintProperty(MAP_LAYERS.allBoundaries, "line-opacity", [
      "case",
      ["==", ["get", "level"], level],
      OPACITIES.FULL,
      OPACITIES.INVISIBLE,
    ]);
  }
};

export const increaseOpacityWhenSelected = (
  map: MutableRefObject<Map>,
  editingContextStore: MutableRefObject<EditingContextStore>,
  blocksBySchool: BlocksBySchool,
) => {
  const currentZone = editingContextStore.current.currentZone;
  if (editingContextStore.current.zoneSelected)
    map.current.setPaintProperty(MAP_LAYERS.swappableBlocks, "fill-opacity", [
      "case",
      [
        "in",
        ["get", "pb_id"],
        ["literal", blocksBySchool?.[currentZone.esID]?.pb_ids],
      ],
      OPACITIES.HIGHLIGHTED,
      ["==", ["get", "pb_id"], editingContextStore.current.hoveredBlock],
      OPACITIES.HIGHLIGHTED,
      OPACITIES.DEFAULT,
    ]);
  else
    map.current.setPaintProperty(
      MAP_LAYERS.swappableBlocks,
      "fill-opacity",
      OPACITIES.DEFAULT,
    );
};

export const showSchoolsByLevelEditor = (
  map: MutableRefObject<Map>,
  level: SchoolType,
) => {
  map.current.setPaintProperty(
    MAP_LAYERS.schoolPoints,
    "circle-color",

    [
      "match",
      level,
      "ES",
      MAP_COLORS.ES,
      "MS",
      MAP_COLORS.MS,
      "HS",
      MAP_COLORS.HS,
      "#000",
    ],
  );
  map.current.setFilter(MAP_LAYERS.schoolPoints, [
    "all",
    ["==", ["get", "school_level"], level],
    ["==", ["get", "scenario_id"], 1],
    ["==", ["get", "school_sector"], "DCPS by-right"],
  ]);
};
